// extracted by mini-css-extract-plugin
module.exports = {"TwitterBio":"F3H4Aa_8","top":"_1Lkh84oK"};